import FTAnalytic from "@/analyze/FTAnalytic";
import { NAV_POSITION, PROJECT_TYPE } from "@/constants";
import { useCommonStore, useUserStore } from "@/stores";
import { FeatureType } from "@/stores/useCommonStore";

const getCommonAnalyseObj = async (immediately?: boolean) => {
  if(!immediately){
    await new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, 100);
    });
  }
  const {
    featureType,
    swapList,
    activeGroup,
    activeMutiGroup,
    generatVideoType,
    getters: { activeBaseTemp, task, isUseRemains }
  } = useCommonStore.getState();

  const isSingle = featureType === FeatureType.Single;
  const id = activeBaseTemp?.id ?? "";
  const isCustom = id.startsWith("CUSTOM") || id === "";
  const resourceId = isCustom ? "custom_temp" : id;
  const sizeId = isCustom
    ? ""
    : isSingle
      ? activeGroup?.id
      : activeMutiGroup?.id;
  const sizeName = isCustom
    ? ""
    : isSingle
      ? activeGroup?.title
      : activeMutiGroup?.title;
  const { isLogin } = useUserStore.getState().getters;
  // 只有视频需要生成类型，其它的传undefined会自动忽略
  const action_type = featureType === FeatureType.Video ? generatVideoType : undefined;
  const vip_type = isUseRemains ? "free" : "credits"

  return {
    featureType,
    swapList,
    activeGroup,
    activeMutiGroup,
    activeTemp: activeBaseTemp,
    isSingle,
    id,
    isCustom,
    resourceId,
    sizeId,
    sizeName,
    project_type: PROJECT_TYPE,
    type: featureType + "_swap",
    task_id: task?.taskId ?? "",
    isLogin,
    face_swap_count: isSingle ? 1 : swapList.length,
    action_type,
    vip_type,
  };
};



export default class Analyse {
  private static instance: Analyse;

  private constructor() { }
  projectType = PROJECT_TYPE;

  public static getInstance(): Analyse {
    if (!Analyse.instance) {
      Analyse.instance = new Analyse();
    }
    return Analyse.instance;
  }
  async enterPage() {
    const { featureType } = await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$enter$swap_project_page",
      label: {
        location: NAV_POSITION,
        project_type: PROJECT_TYPE,
        button_position: featureType,
      },
    });
  }

  async generateCallBack(isSuccess: boolean, failReason: string, other?: any) {
    const {
      type,
      project_type,
      face_swap_count,
      resourceId,
      sizeId,
      sizeName,
      isLogin,
      task_id,
      action_type,
      vip_type,
    } = await getCommonAnalyseObj(true);
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$callback$swap_project_results",
      label: {
        is_success: isSuccess,
        fail_reason: failReason,
        project_type,
        type: type,
        face_swap_count,
        resource_id: resourceId,
        size_id: sizeId,
        size_name: sizeName,
        is_login: isLogin,
        taskid: task_id,
        action_type,
        vip_type,
      },
    });
  }
  /**
   * 打开模板
   */
  async openTarget() {
    const {
      type,
      project_type,
      face_swap_count,
      resourceId,
      sizeId,
      sizeName,
    } = await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$click_up$swap_project_page_open",
      label: {
        type,
        project_type,
        position: "target",
        face_swap_count,
        resource_id: resourceId,
        size_id: sizeId,
        size_name: sizeName,
      },
    });
  }
  async openTargetCallback(isSuccess: boolean, failReason: string) {
    const {
      type,
      project_type,
      resourceId,
      sizeId,
      sizeName,
      face_swap_count,
    } = await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$callback$swap_project_page_open",
      label: {
        type,
        project_type,
        position: "target",
        face_swap_count,
        is_success: isSuccess,
        fail_reason: failReason,
        resource_id: resourceId,
        size_id: sizeId,
        size_name: sizeName,
      },
    });
  }

  async openFaceSwap() {
    const { type, project_type, face_swap_count } = await getCommonAnalyseObj();

    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$click_up$swap_project_page_open",
      label: {
        type,
        project_type,
        position: "face",
        face_swap_count,
      },
    });
  }

  async openFaceSwapCallback(isSuccess: boolean, failReason: string) {
    const { type, project_type, face_swap_count } = await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$callback$swap_project_page_open",
      label: {
        type,
        project_type,
        position: "face",
        is_success: isSuccess,
        fail_reason: failReason,
        face_swap_count,
      },
    });
  }

  async clickUpGenerate(button_status: "start" | "no_credits" | "no_login") {
    const {
      type,
      project_type,
      face_swap_count,
      resourceId,
      sizeId,
      sizeName,
      isLogin,
      action_type,
      vip_type,
    } = await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$click_up$swap_project_page_features",
      label: {
        type,
        project_type,
        position: "face",
        button_position: "startswap",
        button_status,
        face_swap_count,
        resource_id: resourceId,
        size_id: sizeId,
        size_name: sizeName,
        is_login: isLogin,
        action_type,
        vip_type,
      },
    });
  }
  async startGererate() {
    const {
      type,
      project_type,
      face_swap_count,
      resourceId,
      sizeId,
      sizeName,
      isLogin,
      task_id,
      action_type,
      vip_type,
    } = await getCommonAnalyseObj(true);
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$start$swap_project_page_features",
      label: {
        is_success: true,
        type,
        project_type,
        face_swap_count,
        resource_id: resourceId,
        size_id: sizeId,
        size_name: sizeName,
        is_login: isLogin,
        button_status: "start",
        button_position: "startswap",
        position: "face",
        taskid: task_id,
        action_type,
        vip_type,
      },
    });
  }
  async startGererateError(is_success: boolean, fail_reason: string) {
    const {
      type,
      project_type,
      face_swap_count,
      resourceId,
      sizeId,
      sizeName,
      isLogin,
      task_id,
    } = await getCommonAnalyseObj(true);
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$start$swap_project_page_features",
      label: {
        is_success: is_success,
        fail_reason: fail_reason,
        position: "face",
        type,
        project_type,
        face_swap_count,
        resource_id: resourceId,
        size_id: sizeId,
        size_name: sizeName,
        is_login: isLogin,
        button_status: "start",
        button_position: "startswap",
        taskid: task_id,
      },
    });
  }

  async download(button_position: string) {
    const {
      type,
      project_type,
      face_swap_count,
      resourceId,
      sizeId,
      sizeName,
      task_id,
    } = await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$click_up$swap_project_page_download",
      label: {
        type,
        project_type,
        face_swap_count,
        resource_id: resourceId,
        size_id: sizeId,
        size_name: sizeName,
        button_position: button_position,
        taskid: task_id,
      },
    });
  }

  async downloadResult(button_position: string, is_success: boolean) {
    const {
      type,
      project_type,
      face_swap_count,
      resourceId,
      sizeId,
      sizeName,
      task_id,
    } = await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$callback$swap_project_page_download",
      label: {
        type,
        project_type,
        face_swap_count,
        resource_id: resourceId,
        size_id: sizeId,
        size_name: sizeName,
        button_position: button_position,
        taskid: task_id,
        is_success: is_success,
      },
    });
  }

  async featureClick(button_position: string) {
    const { type, project_type } = await getCommonAnalyseObj();
    FTAnalytic.addAnalytic({
      type: "ev",
      action: "fotor_web$click_up$swap_project_page_features",
      label: {
        type,
        project_type,
        position: type,
        button_position,
      },
    });
  }
}
